import React,{useState,useEffect} from 'react';
import { getBusiness } from '../Services/business.service';
import axios from "axios";
import { Link, withRouter,NavLink } from 'react-router-dom';
import DisplayStarIcons from '../Utils/DisplayStarIcons';
import StarRatings from 'react-star-ratings';
import profilePic from '../assets/images/profile1.jpg'
// import ReactSearchBox from "react-search-box";
const WriteReviewFunctional=()=> {
  const [allData,setallData] = useState('filterable');
  const [filterName,setfilterName] = useState('star-high');
  const [filterBusiness,setfilterBusiness] = useState();
  useEffect(() => {
    const fetchPost=() =>{
      // setLoader(true)
      //const res= await axios.get('https://jsonplaceholder.typicode.com/posts');
      getBusiness().then((res)=>{
        setfilterBusiness(res);
       // console.log('business Array is',res);
    });

      // setPost(res.data);
      // setLoader(false)
    }
    fetchPost()
  }, []);
  const setFilterTypeAndFlterData =(e)=>{
      let temp ={};
    switch (e.target.value) {
        case "star-high":
        setfilterName(e.target.value);
        // console.log("About to sort the array : " ,filterBusiness);
        break;
        case "star-low":
        setfilterName(e.target.value);
        break;
        case "star-company":
        setfilterName(e.target.value);
        break;
    
      default:
        break;
    }
   // alert(e.target.value);
    //setfilterName(e.target.value)
  }
  const setCustomFlterData=(e)=>{
    console.log(e.target.value);
    setfilterName(e.target.value);
  }
  // const updateCustomFilterType =()=>{
  //   console.log('Setting the custom search Item :',filterName);
  // }
  return (
    <div className='container-fluid m-0 p-0'>
      {
        typeof filterBusiness === "undefined"?
        <div className="row m-0 pt-5 p-0"style={{minHeight:'75vh'}}>
          <h1 className='mt-5'>Loading business.....</h1>
        </div>:
        <div className='row m-0 p-0'>
           <div className='col-12 m-0 p-0'>
            <div className="my-3 d-flex justify-content-center align-items-center"style={{minHeight:'17%'}}>
              <h2 className="" style={{marginTop:'7rem'}}> Find Reviews of Business</h2>
            </div>
           </div>
           {/*For search Box Start */}
           <div className='col-12 m-0 px-4 p-0'>
            <div className='row mb-2 m-0 p-0'>
              {/* Search Bar */}
              <div className="col-12 mb-3 m-0 px-5">
                 <div className="search" style={{borderRadius:'50px'}}>
                  <i className="fa fa-search"></i>
                  <input  type="text" onChange={(e)=>{setCustomFlterData(e)}} className="form-control" placeholder="Search business here...."/>
                  <button className="btn d-none">Search</button>
                 </div>
              </div>
              {/* Filter column */}
              <div className='col-6 m-0 px-4 p-0'>
                <button className='border border-2'><i class="fa fa-list" aria-hidden="true" onClick={()=>setallData('filterable')}></i></button>
                <button className='border border-2 mx-1'><i class="fa fa-th" aria-hidden="true" onClick={()=>setallData('nonfilter')}></i></button>
              </div>
              {/* filter and Change column */}
              <div className='col-6 m-0 px-5 p-0 d-flex align-items-center justify-content-end'>
              
              {
                allData==='filterable'?
                
              <select onChange={(e)=>{setFilterTypeAndFlterData(e)}} className="form-select fs-5 filterSelect" aria-label="Default select example">
               <option selected value="star-high" >Sort by Rating (High to Low)</option>
               <option value="star-low">Sort by Rating (Low to High)</option>
               <option value="star-company">Sort by Company Name (A - Z)</option>  
              </select>
                :null         
              }
              </div>
              {/* Show Component */}
              <div className='col-12 m-0 py-2 p-0'>
              {
                console.log(filterBusiness)
              }
              {
                (filterBusiness&&filterBusiness)&&allData==='filterable'?<FilterData filterType={filterName} filterData={filterBusiness}></FilterData>:null
              }
              {
                allData==='nonfilter'?<NonfilterData></NonfilterData>:null
              }
              </div>
            </div>
           
           </div>
           {/* For search Box end */}
        </div>
      }
    </div>
  )
}

export default WriteReviewFunctional
const NonfilterData=(props)=>{
  const [realBusinesses,setrealBusinesses] = useState();
  useEffect(() => {
    const fetchPost=async () =>{
      // setLoader(true)
      const res= await axios.get('https://jsonplaceholder.typicode.com/posts');
      getBusiness().then((res)=>{
        setrealBusinesses(res);
        console.log('business Array is',res);
    });
      // setPost(res.data);
      // setLoader(false)
    }
    fetchPost()
  }, []);

   return(
    <div className="row most-review mb-4 p-5">
    {
      realBusinesses&&realBusinesses.map((item,index)=>(

        <div className="col-lg-4 col-md-6 mb-3" key={index}>    
          <NavLink className="businessCard" to="/description">
          <div className="imgDiv">
            {console.log(item)}
              <img src={item.coverPhotoURL} alt="" />
              <div className="textDiv">
                  <h4 className="mb-3">{item.name}</h4>
                  <div><address>{item.address}{item.city}</address></div>
                  <div className="phone"><i class="fa fa-phone mr-1" aria-hidden="true"></i>{item.phoneNumber}</div>
              </div>
          </div>
          <div className="ratingDiv">
              <div className="">
              <StarRatings
              rating={item.businessCount%5}
              starDimension="18px"
              starSpacing="1px"
              numberOfStars={5}
              starRatedColor="orange"
          />
              </div>
              <div className="profileDiv"><img src={item.logoURL} alt="logo" /></div>
          </div>
          </NavLink>
        </div>
        ))
    }
</div>
    
   )
}
const FilterData=(props)=>{
  const [filterType,setFilterType] = useState();
  const [filterArray,setfilterArray] = useState();
  const [customItemIndex,setcustomItemIndex] = useState();
  const [refreshAfterSearch,setrefreshAfterSearch] = useState(false);
  useEffect(()=>{
    ///alert('filter type fom the parent is ',props.filterType)
    let temp ={};
    switch (props.filterType) {
        case "star-high":
       // setfilterName(e.target.value);
        console.log("Sort the High to low : " ,props.filterData);
        for (let i=0; i<props.filterData.length-1;i++){
            for(let j=i+1;j<props.filterData.length;j++)
            {
              if((props.filterData[i].businessCount)<(props.filterData[j].businessCount))
                {temp = props.filterData[i];
                props.filterData[i]=props.filterData[j];
                props.filterData[j]=temp;
                }
            }
        }
        //setFilterType(props.filterType);
        setfilterArray(props.filterData);
        console.log('Sorted Data is : ',props.filterData)
        break;
        case "star-low":
          console.log("Sort the low to High : " ,props.filterData);
          for (let i=0; i<props.filterData.length-1;i++){
            for(let j=i+1;j<props.filterData.length;j++)
            {
              if((props.filterData[i].businessCount)>(props.filterData[j].businessCount))
                {temp = props.filterData[i];
                props.filterData[i]=props.filterData[j];
                props.filterData[j]=temp;
                }
            }
        }
        setFilterType(props.filterType);
        setfilterArray(props.filterData);
        //setfilterName(e.target.value);
        break;
        case "star-company":
          props.filterData.sort((a,b) => (a.name > b.name) ? 1 : ((b.name > a.name) ? -1 : 0));
          console.log('Filter By business name',props.filterData);
          setFilterType(props.filterType);
          setfilterArray(props.filterData);
        break;
      default:
        for(let i=0;i<filterArray.length;i++){
          console.log(i);
           if((props.filterData[i].name.toLowerCase())===(props.filterType.toLowerCase())){
             console.log('it will wor when none of the case is working',filterArray[i].name);
             setFilterType('custom');
             setcustomItemIndex(i);
             break;
           }
           if((i+1)===(filterArray.length))
           {
            setFilterType('Buniness not found');
            console.log('Business is not found');
            setrefreshAfterSearch(true);
            //setFilterType('Buniness not found');
           }
        }
      break;
    }
    console.log('Making concept clear :',filterType);
    console.log('length of the filter type is ',props.filterType)
    console.log(props.filterType.length)
    if(props.filterType.length === 0)
    {
      setFilterType("star-high");
    }
    //console.log('Making concept clear :',props.filterType);
    //console.log('Making concept clear :',props.filterData,' finally get worked');
  },[props.filterType])
  return(
    <>
    
    {
     (typeof filterArray === "undefined")?
      <h1>Some thing went wrong while fetching data from firebase</h1>:
      filterType==='Buniness not found'?<h1>No record found</h1>:
      filterType!=='custom'?
      <div className='container-fluid m-0 p-3'>
      {
        filterArray&&filterArray.map((item,index)=>
        <div className='row mb-4 m-0 p-0' key={index}>
       <div className='col-12 col-sm-8 m-0 p-0 d-flex'>
           <div className="reviewPageListImg mx-2">
            <img src={item.coverPhotoURL} alt="profilePic" />
           </div>
           <div>
       <p className="mb-1" style={{fontWeight:'bold'}}>{item.name} </p>
       <p className="mb-0">Address: {item.address}</p>

       <span>Phone: {item.phoneNumber} </span>
       <div> Current Rating : {DisplayStarIcons(item.businessCount)}</div>
       <div className="d-md-none write-review border w-75 rounded-pill">  
            <Link className="btn buttons reviewPage-WriteBtn w-100 fs-5 p-0" to={`/company-rate/${item.businessId}`}>Write Review</Link>                                             
       </div>
       <div className="tag">
       </div>                      
       </div>
       </div>
       <div className='col-12 col-sm-4 m-0 p-0 d-flex justify-content-center align-items-center'>
           <div className="d-none d-md-block write-review border rounded-pill">  
            <Link className="btn buttons reviewPage-WriteBtn w-100 fs-5 p-0" to={`/company-rate/${item.businessId}`}>Write Review</Link>                                             
            </div>
       </div>
       </div>)
      }
    </div>:
    <div className='container-fluid m-0 p-3'>
    <div className='row mb-4 m-0 p-0'>
    <div className='col-8 m-0 p-0 d-flex'>
       <div className="reviewPageListImg mx-2">
        <img src={filterArray[customItemIndex].coverPhotoURL} alt="profilePic" />
       </div>
       <div>
    <p className="mb-1" style={{fontWeight:'bold'}}>Business Name {filterArray[customItemIndex].name} </p>
    <p className="mb-0">Address: {filterArray[customItemIndex].address}</p>
    
    <span>Phone: {filterArray[customItemIndex].phoneNumber} </span>
    <div> Current Rating : {DisplayStarIcons(filterArray[customItemIndex].businessCount)}</div>
    <div className="tag">
    </div>                      
    </div>
    </div>
    <div className='col-4 m-0 p-0 d-flex justify-content-center align-items-center'>
       <div className="write-review border rounded-pill">  
        <Link className="btn buttons reviewPage-WriteBtn w-100 fs-5 p-0" to={{pathname:`/rate-company/${filterArray[customItemIndex].businessId}`}}>Write Review</Link>                                             
        </div>
    </div>
    </div>
    </div>
   }
    </>
  )
}

          //  {
          //    console.log('Business Id before sending to review ',item.businessId)
          //  }